import * as actionTypes from "../ActionTypes";

// SAVE
export const saveProgramVideoRequest = (apiPayloadRequest, callback) => ({
    type: actionTypes.SAVE_PROGRAM_VIDEO_REQUEST,
    payload: { apiPayloadRequest },
    callback,
  });
  

export const saveProgramVideoSuccess = (data) => ({
  type: actionTypes.SAVE_PROGRAM_VIDEO_SUCCESS,
  payload: data,
});

export const saveProgramVideoFailure = (error) => ({
  type: actionTypes.SAVE_PROGRAM_VIDEO_FAILURE,
  payload: error,
});

// UPDATE
export const updateProgramVideoRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_PROGRAM_VIDEO_REQUEST,
  payload: { apiPayloadRequest },
  callback,
});

export const updateProgramVideoSuccess = (data) => ({
  type: actionTypes.UPDATE_PROGRAM_VIDEO_SUCCESS,
  payload: data,
});

export const updateProgramVideoFailure = (error) => ({
  type: actionTypes.UPDATE_PROGRAM_VIDEO_FAILURE,
  payload: error,
});

// DELETE
export const deleteProgramVideoRequest = (payload, callback) => ({
  type: actionTypes.DELETE_PROGRAM_VIDEO_REQUEST,
  payload,
  callback,
});

export const deleteProgramVideoSuccess = (data) => ({
  type: actionTypes.DELETE_PROGRAM_VIDEO_SUCCESS,
  payload: data,
});

export const deleteProgramVideoFailure = (error) => ({
  type: actionTypes.DELETE_PROGRAM_VIDEO_FAILURE,
  payload: error,
});

// READ
export const readProgramVideoRequest = (payload, callback) => ({
  type: actionTypes.READ_PROGRAM_VIDEO_REQUEST,
  payload,
  callback,
});

export const readProgramVideoSuccess = (data) => ({
  type: actionTypes.READ_PROGRAM_VIDEO_SUCCESS,
  payload: data,
});

export const readProgramVideoFailure = (error) => ({
  type: actionTypes.READ_PROGRAM_VIDEO_FAILURE,
  payload: error,
});
